import client from '../client'

export const getDecodeBurstByVinKey = `${process.env.NEXT_PUBLIC_INTEGRATION_DATAKIOSK_ENDPOINT}/GetDecodeBurstByVin`

export async function getDecodeBurstByVin({ vin }) {
  const params = new URLSearchParams({ vin })

  return client(`${getDecodeBurstByVinKey}?${params.toString()}`).then((res) => res.vehicleByVIN)
}
